module.exports = __webpack_public_path__ + "static/media/img_thumb.67f13c3b.svg";